import { render, staticRenderFns } from "./AuthMethod.vue?vue&type=template&id=fbdc1ef2&scoped=true&lang=pug"
import script from "./AuthMethod.vue?vue&type=script&lang=js"
export * from "./AuthMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdc1ef2",
  null
  
)

export default component.exports